module.exports = __webpack_public_path__ + "img/7.e84a6904.png";